export default __webpack_public_path__ + "static/media/policyF.0e74d98e.png";